import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-ssltest',
    templateUrl: './ssltest.component.html',
    styleUrls: ['./ssltest.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class SsltestComponent implements OnInit {
  t$ = fetch('https://192.168.88.79/test.json', {}).then((v) => {
    return v.json();
  });

  constructor() {}

  ngOnInit(): void {}
}
